import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { displayCurrencyPlaceholder, formatCurrency } from '@/utils/money';
import { MenuItem } from '@/contexts/menu-info-context';
import { MenuItemPriceInputs } from './menu-item-price-inputs';
import { SCREEN_PADDING, shadow, TYPOGRAPHY } from '@/styles';
import { Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';

interface Props {
  menuItem: MenuItem;
}

export const MenuItemPriceFooter: React.FC<Props> = ({ menuItem }) => {
  const [styles] = useStyles();
  const { bottom } = useSafeAreaInsets();
  const { currencyCode } = useVariantPackInfoContext();

  return menuItem.ingredients.length ? (
    <View
      style={[styles.base, { paddingBottom: Math.max(bottom, SCREEN_PADDING) }]}
    >
      <View style={styles.row}>
        <Text style={TYPOGRAPHY.h3}>
          {i18n.t('menu_item.total_plate_cost')}
        </Text>
        <Text style={TYPOGRAPHY.h3Bold}>
          {menuItem.plateCostInMicros
            ? formatCurrency(menuItem.plateCostInMicros, currencyCode)
            : displayCurrencyPlaceholder(currencyCode)}
        </Text>
      </View>
      <MenuItemPriceInputs menuItem={menuItem} style={styles.row} />
    </View>
  ) : null;
};

const useStyles = createStyles((theme) => ({
  base: {
    ...shadow({
      color: theme.colors.black,
      opacity: 0.1,
      radius: 4,
      x: 0,
      y: -4,
    }),
    backgroundColor: theme.colors.white,
    borderTopColor: theme.colors.stroke,
    borderTopWidth: 1,
    gap: 16,
    padding: 24,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
